import Vue from "vue";
import Vuex from "vuex";
import API_PARKINGS from "../../api/parkings.api";

Vue.use(Vuex);

export const INITIAL_STATE = {
  parkings: [],
};

export default {
  state: () => ({ ...INITIAL_STATE }),
  getters: {
    parkings: (state) => state.parkings,
    parkingById: (state) => (id) => state.parkings.find((p) => p.id === id),
  },
  mutations: {
    fetch_parkings(state, newContent) {
      state.parkings = newContent ?? [];
    },
  },
  actions: {
    async fetch_parkings({ commit, getters }) {
      const response = await API_PARKINGS.getParkings(
        getters.selectedClient.id
      );
      commit("fetch_parkings", response);
      return "OK";
    },

    async create_parking({ getters, dispatch }, data) {
      await API_PARKINGS.createParking(getters.selectedClient.id, data);
      await dispatch("fetch_parkings");
      return "OK";
    },

    async update_parking({ getters, dispatch }, data) {
      await API_PARKINGS.updateParking(getters.selectedClient.id, data);
      await dispatch("fetch_parkings");
      return "OK";
    },
  },
};
